/* =======================================================================
   theme-custom.js — personnalisations propres à la boutique
   ======================================================================= */

/**
 * Notify! — bouton « ouvrir la liste de souhaits » dans le header
 * ------------------------------------------------------------------
 * Le thème rend un bouton statique dans le header (.header__wishlist-link,
 * cf. sections/header.liquid) afin de réserver l'espace dès le premier rendu
 * (anti-CLS) et de garder la main sur son aspect.
 *
 * L'app Notify! attache son comportement (ouverture du drawer) DIRECTEMENT
 * sur SON propre bouton, qu'elle (re)crée dans un portail au niveau du <body>
 * et que le CSS masque (cf. theme-custom.css). Elle n'utilise pas de
 * délégation : elle n'écoute donc pas les clics de notre bouton du header.
 *
 * On relaie par conséquent le clic du bouton du header vers le vrai bouton de
 * l'app. On le retrouve à chaque clic, car l'app le supprime puis le recrée à
 * chaque ouverture/fermeture de la modale.
 */
(function () {
  'use strict';

  var SLOT_SELECTOR = '.header__wishlist-link';
  var BUTTON_SELECTOR = '.nm-wishlist-open-list-button';

  var slot = document.querySelector(SLOT_SELECTOR);
  if (!slot) return;

  var trigger = slot.querySelector(BUTTON_SELECTOR);
  if (!trigger) return;

  // Bouton réel de l'app = un .nm-wishlist-open-list-button situé hors du header.
  function findAppButton() {
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      if (!slot.contains(buttons[i])) return buttons[i];
    }
    return null;
  }

  trigger.addEventListener('click', function (event) {
    var appButton = findAppButton();
    if (!appButton) return; // app pas encore initialisée : on ne fait rien
    event.preventDefault();
    appButton.click();
  });
})();
